import { render, staticRenderFns } from "./FormBuilderNavPanel.vue?vue&type=template&id=5f4d540a&"
import script from "./FormBuilderNavPanel.vue?vue&type=script&lang=js&"
export * from "./FormBuilderNavPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports